import axios from 'axios';
import { buildApiUrl } from '../config/api';

export const ProductService = {
    getProducts: async ({ token, pagina = 1, pageSize = 20, nombre = '' }) => {
        try {
            const response = await axios.get(buildApiUrl('/api/productos'), {
                headers: { Authorization: `Bearer ${token}` },
                params: { pagina, pageSize, nombre },
            });

            return {
                productos: response.data.products || [],
                totalPaginas: response.data.totalPaginas || 1,
                totalRegistros: response.data.totalRegistros || 0,
            };
        } catch (error) {
            console.error('Error en ProductService.fetchProductos:', error);
            throw error;
        }
    },
    toggleEstadoProducto: async ({ token, producto }) => {
        try {
            const nuevoEstado = producto.estado === 'ACTIVO' ? 'BAJA' : 'ACTIVO';

            await axios.put(
                buildApiUrl(`/api/productos/${producto.id}`),
                { estado: nuevoEstado },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            return nuevoEstado; // Devuelve el nuevo estado para que el componente lo use
        } catch (error) {
            console.error('Error en ProductService.toggleEstadoProducto:', error);
            throw error;
        }
    },
    registrarProducto: async ({ token, form }) => {
        try {
            await axios.post(buildApiUrl('/api/productos'), form, {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            console.error('Error en ProductService.registrarProducto:', error);
            throw error;
        }
    },
    fetchProductoPorId: async ({ token, id }) => {
        try {
            const response = await axios.get(buildApiUrl(`/api/productos/${id}`), {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data;
        } catch (error) {
            console.error('Error en ProductService.fetchProductoPorId:', error);
            throw error;
        }
    },
    editarProducto: async ({ token, id, form }) => {
        try {
            await axios.put(buildApiUrl(`/api/productos/${id}`), form, {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            console.error('Error en ProductService.editarProducto:', error);
            throw error;
        }
    },
    fetchProductosPorCategoria: async (token,categoriaId) => {
        try {
            const response = await axios.get(buildApiUrl(`/api/productos/categoria/${categoriaId}`), {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data|| [];
        } catch (error) {
            console.error('Error en ProductoService.fetchProductos:', error);
            throw error;
        }
    },
};
